export const Reviews = {
	script:
		"Through CADEMIA I have been able to acquire mastery and confidence in using Civil 3D. Am now the go to person for any Civil 3D related projects at work. I appreciate the tutors for the great content. ",
	name: "Mike, Civil Engineer - Consky Engineering services",
};
